<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_3 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<!--<div-->
		<!--	:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"-->
		<!--	class="my-4"-->
		<!--&gt;</div>-->
		
		<!--<v-row class="mb-5 font-weight-medium">-->
		<!--	<v-col>-->
		<!--		<div v-html="faseWithStati.descrizione"></div>-->
		<!--	</v-col>-->
		<!--</v-row>-->
		
		<v-data-table
			:items="dates"
			:headers="headers"
			:loading="isLoadingDates"
			mobile-breakpoint="6000"
			hide-default-footer
		>
			<template v-slot:item.data_apertura="{ item, index }">
				{{ formatDateToItalyLong(item.data_apertura) || 'IN AGGIORNAMENTO' }}
			</template>
			<template v-slot:item.data_chiusura="{ item, index }">
				{{ formatDateTimeToItalyLong(item.data_chiusura) || 'IN AGGIORNAMENTO' }}
			</template>
			<template v-slot:item.download_codici_identificativi="{ item, index }">
				{{ formatDateToItalyLong(item.download_codici_identificativi) || 'IN AGGIORNAMENTO' }}
			</template>
			<template v-slot:item.regole_tecniche="{ item, index }">
				<!-- Qua dovranno andare 2 link, uno verso le regole tecniche e uno verso la tabella temporale -->
				<!--{{ formatDateToItalyLong(item.regole_tecniche) || 'IN AGGIORNAMENTO' }}-->
				<div>Regole tecniche e modalità di svolgimento, pubblicazione entro il 20/9/2023.</div>
				<div>Tabella temporale, pubblicazione entro il 4/10/2023.</div>
			</template>
			<template v-slot:item.registrazione_portale_partecipante="{ item, index }">
				{{ formatDateTimeToItalyLong(item.registrazione_portale_partecipante) || 'IN AGGIORNAMENTO' }}
			</template>
			<template v-slot:item.data_ora_clickday="{ item, index }">
				{{ formatDateTimeToItalyLong(item.data_ora_clickday) || 'IN AGGIORNAMENTO' }}
			</template>
		</v-data-table>
		
		<div
			v-if="!isLoading"
			class="mt-6 mb-2"
		>
			Leggi le regole tecniche del {{ nomeBando }}
		</div>
		<v-btn
			:href="linkRegoleTecniche"
			color="secondary"
			:disabled="isLoading"
			target="_blank"
		>
			Leggi le Regole Tecniche
		</v-btn>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff'],
	data() {
		return {
			isSettingPratica: false,
			pratica: {
				id: null,
				id_stato_fase_3: null,
				ci_sono_aggiornamenti_fase_3: false,
			},
			isLoadingDates: false,
			dates: [],
			headers: [
				{ text: 'Apertura della procedura informatica per la compilazione della domanda', value: 'data_apertura', sortable: false },
				{ text: 'Chiusura della procedura informatica per la compilazione della domanda', value: 'data_chiusura', sortable: false },
				{ text: 'Download codici identificativi', value: 'download_codici_identificativi', sortable: false },
				{ text: 'Regole tecniche', value: 'regole_tecniche', sortable: false },
				{ text: 'Registrazione Portale Partecipante', value: 'registrazione_portale_partecipante', sortable: false },
				{ text: 'Click Day', value: 'data_ora_clickday', sortable: false },
			],
			nomeBando: null,
			linkRegoleTecniche: null
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		// aggiorno sul db
		if (this.pratica.ci_sono_aggiornamenti_fase_3 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_3 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_3',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_3');
		}
		
		this.getDateClickDay()
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingDates;
		}
	},
	
	watch: {
		pratica: {
			handler(newVal) {
				if (!this.isLoading) {
					this.$emit('input', newVal);
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal);
		},
	},
	
	methods: {
		getDateClickDay() {
			this.isLoadingDates = true;
			axios.get('/api/bandi-simulatore/click-day-dates')
				.then(response => {
					this.dates = response.data;
					this.nomeBando = this.dates[0].nome;
					this.linkRegoleTecniche = this.dates[0].link_regole_tecniche;
				})
				.finally(() => {
					this.isLoadingDates = false;
				})
		}
	}
	
}
</script>

<style scoped>

</style>